import { atom } from 'jotai';

export const contactTracingPatientSearchTextAtom = atom('');

export const contactTracingPatientSearchActiveOnly = atom<boolean>(true);
